module.exports = __webpack_public_path__ + "media/images/minci-f9a5f9cebb31fcc677f65bd1de4eb122.png";